import angular from 'angular';
import Routing from './usage.details.config';
import UsageDetailsComponent from './usage.details.component';
export default angular.module('invision.customercare.customer.usageDetails', []).config(Routing).component('usageDetails', UsageDetailsComponent).name;